import React, { Component } from 'react';

class Transition extends Component {
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default Transition;